module.exports = "<div class=\"fn-block-nav m-b\"><ng-transclude></ng-transclude></div>";